import { render, staticRenderFns } from "./WebSearch.vue?vue&type=template&id=6d9c58ce&"
import script from "./WebSearch.vue?vue&type=script&lang=js&"
export * from "./WebSearch.vue?vue&type=script&lang=js&"
import style0 from "./WebSearch.vue?vue&type=style&index=0&id=6d9c58ce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports